const saveFile = (fileName, language, curCode) => {
  // let type = language === "python" ? "py" : "sql";
  let type;
  switch (language) {
    case "python":
      type = "py";
      break;
    case "sql":
      type = "sql";
      break;
    case "node":
      type = "js";
      break;
    case "java":
      type = "java";
      break;
    case "c++":
      type = "cpp";
      break;
    default:
      break;
  }
  let downLink = document.createElement("a");
  downLink.download = `${fileName}.${type}`;
  let blob = new Blob([curCode]);
  downLink.href = URL.createObjectURL(blob);
  document.body.appendChild(downLink);
  downLink.click();
  document.body.removeChild(downLink);
};
function uploadFile() {}
export default {
  saveFile,
  uploadFile
};
